<template>
  <header class="u-display-none-md-up">
    <h1 class="l-default__content__header__title">
      <i
        @click="$emit('click:menu')"
        class="l-default__content__header__menu-icon icofont-navigation-menu u-display-none-lg-up"
      ></i>
      <Breadcrumbs />
    </h1>
    <logo width="50" class="u-text-align-right" />
  </header>
</template>

<script>
import Logo from "@/components/Shared/Sidebar/Logo.vue";
export default {
  components: {
    Logo,
  },
};
</script>

<style></style>
